import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconWarningYellow24 = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#F9CC15",
		d: "M10.256 3.61 2.17 18.021C1.423 19.354 2.387 21 3.915 21h16.17c1.528 0 2.492-1.645 1.744-2.979L13.744 3.61c-.764-1.362-2.724-1.362-3.488 0"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#2B0E3F",
		d: "M11 8v6h2V8zM11 15.5v2h2v-2z"
	})]
});
const ForwardRef = forwardRef(SvgIconWarningYellow24);
export default ForwardRef;
